export enum ActionType {
  EstimateConverting = 'estimateConverting',
  EditSubproject = 'editSubproject',
  CreateSubproject = 'createSubproject',
  EditProject = 'editProject',
  CreateProject = 'createProject'
}

export enum EstimateUnitType {
  Hour = 7
}
